import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _ from "lodash";
import styles from "./ChartCostToTradeLotSizes.css";
import * as actionCreators from "../../../store/analytics/chart-cost-to-trade-lot-sizes/action-creators";
import _Aux from "../../_Aux";
import { SELECT_EMPTY_VALUE } from "../../../services/managers/constants";
import { TOOLTIP_LOT_SIZE, MSG_LOT_SIZE_MAX_4, MSG_LOT_SIZE_MAX_1 } from "../../../services/managers/string-literals";
import envManager from "../../../services/managers/env";
import mathManager from "../../../services/managers/math";

class ChartCostToTradeLotSizes extends React.Component {
  constructor(props) {
    super(props);

    // Open (or Close) state of Lot Size dropdown
    this.state = { isOpen: false };

    this.openCloseDropdown = this.openCloseDropdown.bind(this);
    this.closeDropdownOnClickingOutside = this.closeDropdownOnClickingOutside.bind(this);
  }

  componentWillMount() {
    document.addEventListener("mousedown", this.closeDropdownOnClickingOutside, false);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.closeDropdownOnClickingOutside, false);
  }

  openCloseDropdown() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  closeDropdownOnClickingOutside(event) {
    // Ignore UI clicks on the component itself
    if (this.node.contains(event.target)) return;

    if (this.state.isOpen) {
      this.setState({ isOpen: false });
    }
  }

  constructTable() {
    let chunkedLotSizes = _.chunk(this.props.costToTradeLotSizes, 5);
    let lotSizesDoc = null;
    lotSizesDoc = chunkedLotSizes.map((lotSizesChunk, index) => (
      <tr key={index}>
        {lotSizesChunk.map((lsObj) => (
          <td
            key={lsObj.Key}
            className={styles["lot-size-square"] + " " + (_.includes(this.props.selectedCostToTradeLotSizes, lsObj.Key) ? styles.highlight : "")}
            onClick={() => this.props.onSelectedCostToTradeLotSizesChange(this.props.whiteboardIndex, lsObj.Key)}>
            {mathManager.toUSANumberFormat(lsObj.Val)}
          </td>
        ))}
      </tr>
    ));
    return lotSizesDoc;
  }

  render() {
    let show = this.state.isOpen ? styles["show"] : styles["hide"];

    let isOverlayComparisonActive =
      this.props.selectedPrimaryChart !== SELECT_EMPTY_VALUE && this.props.selectedComparisonChart !== SELECT_EMPTY_VALUE;

    let message = MSG_LOT_SIZE_MAX_4;
    if (isOverlayComparisonActive && !envManager.areMultipleLotSizesAllowedForOverlayComparison()) {
      message = MSG_LOT_SIZE_MAX_1;
    }

    // Displaying selected Lot Sizes separated by semi-colon
    let selectedLotSizesToBeDisplayed = [];
    _.forEach(this.props.selectedCostToTradeLotSizes, (Key) => {
      selectedLotSizesToBeDisplayed.push(mathManager.toUSANumberFormat(_.find(this.props.costToTradeLotSizes, { Key })["Val"]));
    });

    return (
      <_Aux>
        <label>Lot Sizes</label>
        <div className={styles["dropdown"]} ref={(node) => (this.node = node)}>
          <button className={"btn btn--secondary " + styles["dropbtn"]} type="button" onClick={this.openCloseDropdown} title={TOOLTIP_LOT_SIZE}>
            {selectedLotSizesToBeDisplayed.join("; ").trim()}
            <i className="fa fa-caret-down" />
          </button>
          <div id="myDropdown" className={show}>
            <table className={styles["dropdownTable"]}>
              <tbody>
                {this.constructTable()}
                <tr>
                  <td className={styles["lot-sizes-message"]} colSpan="5">
                    {message}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </_Aux>
    );
  }
}

ChartCostToTradeLotSizes.propTypes = {
  whiteboardIndex: PropTypes.number.isRequired,
  costToTradeLotSizes: PropTypes.array.isRequired,
  selectedCostToTradeLotSizes: PropTypes.array.isRequired
};

const mapStateToProps = (state) => ({
  costToTradeLotSizes: state.analytics.costToTradeLotSizes
});

const mapDispatchToProps = (dispatch) => ({
  onSelectedCostToTradeLotSizesChange: (whiteboardIndex, value) =>
    dispatch(actionCreators.onSelectedCostToTradeLotSizesChange({ whiteboardIndex, value }))
});

export default connect(mapStateToProps, mapDispatchToProps)(ChartCostToTradeLotSizes);



// WEBPACK FOOTER //
// ./src/components/Analytics/ChartCostToTradeLotSizes/ChartCostToTradeLotSizes.js